import notificationMessages from './notifications.json'

const hasOwn = <ObjectType extends object>(
  object: ObjectType,
  key: PropertyKey,
): key is keyof ObjectType => Object.prototype.hasOwnProperty.call(object, key)

function replaceVariable(message: string, variable: string): string {
  return message.replace(/{{__variable__}}/, variable)
}

function getNotificationMessage(
  type: string | null | undefined,
  key: string | null | undefined,
  variable: string | null | undefined,
): string | null {
  if (!type || !hasOwn(notificationMessages, type) || !key) {
    return null
  }

  const messages = notificationMessages[type]
  if (!hasOwn(messages, key)) {
    return null
  }

  const message = messages[key]

  if (variable) {
    return replaceVariable(message, variable)
  }

  return message
}

export default getNotificationMessage
